var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.166 1.703v4.848a1.08 1.08 0 0 1-1.08 1.079H1.75a.585.585 0 0 1-.583-.583V3.318c0-1.19.963-2.152 2.153-2.152h4.305c.303 0 .542.239.542.536z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.541 9.041c.163 0 .292.129.292.292v.583c0 .969-.782 1.75-1.75 1.75 0-.962-.788-1.75-1.75-1.75-.963 0-1.75.788-1.75 1.75H6.416c0-.962-.787-1.75-1.75-1.75-.962 0-1.75.788-1.75 1.75-.968 0-1.75-.781-1.75-1.75V8.75c0-.321.263-.584.583-.584h5.542c.805 0 1.458-.653 1.458-1.458V3.5c0-.321.263-.583.584-.583h.49c.42 0 .805.227 1.015.589l.373.653a.147.147 0 0 1-.128.216c-.805 0-1.459.653-1.459 1.458v1.75c0 .805.654 1.458 1.459 1.458h1.458z",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 12.833a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333zM9.333 12.833a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333zM12.833 7.31v.857h-1.75a.585.585 0 0 1-.583-.584v-1.75c0-.32.262-.583.583-.583h.753l.846 1.482c.099.175.151.373.151.577z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDriver);
export default __webpack_public_path__ + "static/media/ic_driver.2b4e4d691ef349949bd16b6152f5b41e.svg";
export { ForwardRef as ReactComponent };